var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteRightDoubleArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03151 17.8757C6.70806 17.6169 6.65562 17.1449 6.91438 16.8215L10.5396 12.29L6.91438 7.75853C6.65562 7.43509 6.70806 6.96312 7.03151 6.70436C7.35495 6.4456 7.82692 6.49804 8.08568 6.82149L12.0857 11.8215C12.3048 12.0954 12.3048 12.4846 12.0857 12.7585L8.08568 17.7585C7.82692 18.082 7.35495 18.1344 7.03151 17.8757Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5315 17.8757C12.2081 17.6169 12.1556 17.1449 12.4144 16.8215L16.0396 12.29L12.4144 7.75853C12.1556 7.43509 12.2081 6.96312 12.5315 6.70436C12.855 6.4456 13.3269 6.49804 13.5857 6.82149L17.5857 11.8215C17.8048 12.0954 17.8048 12.4846 17.5857 12.7585L13.5857 17.7585C13.3269 18.082 12.855 18.1344 12.5315 17.8757Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRightDoubleArrow);
export default __webpack_public_path__ + "static/media/whiteRightDoubleArrow.e93adba8c81af3578309755a9863e470.svg";
export { ForwardRef as ReactComponent };